import { Box, Stack } from '@mui/material';
import { Descope } from '@descope/react-sdk';
import React from 'react';
import { useThemeCtx } from 'state/theme/ThemeCtx';

interface ILoginFlowViewProps {
	flowId: string;
	styleId?: string | undefined;
}

const LoginFlowView: React.FC<ILoginFlowViewProps> = ({
	flowId,
	styleId = undefined
}) => {
	const { mode } = useThemeCtx();

	return (
		<Stack alignItems="center" justifyContent="space-around" height="100%">
			<Stack maxWidth={800} width="100%">
				<Descope flowId={flowId} styleId={styleId} theme={mode} />
			</Stack>
			<Box />
		</Stack>
	);
};

export default LoginFlowView;
